import { render, staticRenderFns } from "./succes1.vue?vue&type=template&id=85ba773e&scoped=true&"
import script from "./succes1.vue?vue&type=script&lang=js&"
export * from "./succes1.vue?vue&type=script&lang=js&"
import style0 from "./succes1.vue?vue&type=style&index=0&id=85ba773e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba773e",
  null
  
)

export default component.exports